// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../components/Images/break-ad.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../components/Images/playout-live.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../components/Images/playout-video.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-container {
    position: relative;
    display: inline-block;
 }

 /* .clear-button {
    position: absolute;
    top: 10px;
    left: 80%;
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #aaa;
 } */
 
 .clear-button:hover {
    color: #000;
 }
 .remove-text {
   color: black; 
   font-weight: 600; 
   cursor: pointer;
   transition: color 0.2s ease-in-out; 
}

.remove-text:hover {
   color: red !important;
}
.payout-actions {
   display: flex;
   align-self: self-end;
   margin-top: 5px;
}
.payout-disable-btn {
   padding: 5px 10px;
   border: 1px solid grey;
   border-radius: 5px;
   color: black;
}
.payout-disable-btn:hover 
{
   background-color: #aaa !important; 
}
.editplayouttdtd td{
       padding: 20px 20px 20px 10px !important;
}
.payout-delete-btn {
   padding: 5px 10px;
   border: none;
   border-radius: 5px;
   cursor: pointer;
   transition: background-color 0.3s;
}

.payout-delete-btn:hover {
   color: red;;
}

.custom-fade-modal .modal-backdrop {
   background: rgba(0, 0, 0, 0.5) !important; 
}

.custom-fade-modal .modal-content {
   animation: none;
}
.adjust-retain
{
   font-size: 15px;
}
.live-custom, .vod-custom {
   color: black !important;
   border-bottom: 2px solid transparent; 
   transition: all 0.3s ease-in-out;
   font-weight: 700 !important;
   margin-top: 22px;
}

.live-custom.active, .vod-custom.active {
   color: #0d6efd !important; 
   border-bottom: 2px solid #0d6efd !important; 
}
.livestream-container {
   background-color: #10172a;
   padding: 10px;
   border-radius: 8px;
 }
 
 /* Navigation Tabs */
 .custom-nav-tabs {
   display: flex;
   border-bottom: 1px solid #394b68;
 }
 
 .tab-live, .tab-vod {
   color: #ccc;
   background: transparent;
   border: none;
   font-size: 14px;
   padding: 8px 12px;
 }
 
 .tab-live.active {
   color: #007bff;
   font-weight: bold;
   border-bottom: 2px solid #007bff;
 }
 
/* Search Box Styling */
.search-wrapper {
   display: flex;
   align-items: center;
   padding: 5px;
   width: 100%;
   border: 1px solid grey;
   border-radius: 5px;
   background: white;
   position: relative;
}

.edittv_icon {
   width: 20px;
   height: 20px;
   margin-right: 8px; 
   vertical-align: middle;
   font-size: 8px;
   color:#b9b9b9
}

.search-wrapper, .break-wrapper {
   display: flex;
   align-items: center;
}

.search-box {
   flex: 1 1;
   padding: 8px 10px;
   border: none;
   outline: none;
   font-size: 14px;
}

/* Breaks Row Styling */
.breaks-container {
   display: flex;
   align-items: center;
   justify-content: space-between;
   padding: 8px;
   width: 100%;
   border: 1px solid grey;
   border-radius: 5px;
   margin: 8px 0;
   background: white;
}

.break-add-icon {
   cursor: pointer;
   font-size: 20px;
   color: grey;
   transition: 0.3s;
}

.break-add-icon:hover {
   color: black;
}

.video-thumb {
   font-size: 18px;
   color: grey;
}
.editimglive {
   font-size: 50px;
   color: grey;
}

.live-add-icon {
   cursor: pointer;
   font-size: 20px;
   color: grey;
   transition: 0.3s;
}

.live-add-icon:hover {
   color: black;
}

 .livestream-table {
   width: 100%;
   margin-top: 10px;
 }
 .video-table {
   width: 100%;
   margin-top: 10px;
 }

 .live-item {
   display: inherit !important;
   align-items: center;
   border-bottom: transparent !important;
   margin-bottom: 5px;
}
 .breaks-row
 {
   display: flex;
   align-items: center;
   border-bottom: transparent !important;
   margin-bottom: 5px;

 }
 .video-item {
   display: inherit !important;
   align-items: center;
   border-bottom: transparent !important;
   margin-bottom: 5px;
   width: 100%;

 }
 .breaks-container td {
   border-bottom: transparent !important;
}

 .break-icon, .video-icon {
   color: white;
   margin-right: 8px;
 }
 
 .add-icon {
   color: #007bff;
   font-size: 20px;
   cursor: pointer;
 }
 .middle-content {
   display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 20px;
    bottom: 10px !important;
    margin-top: 20%
}
.tooltip-retain-content {
   max-width: 180px; 
   white-space: normal;
   word-wrap: break-word;
   text-align: start;
   line-height: 1.4;
   padding: 5px;
   z-index: 9999 !important;
   position: relative; 
}
.tooltip-break-content {
   max-width: 300px;
   white-space: normal;
   word-wrap: break-word;
   text-align: start;
   z-index: 1050; 
}
.tooltip-break-wrapper {
   overflow: hidden;
}
.custom-time-picker {
   width: 200px;
   height: 40px;
   background: white;
   border-radius: 6px;
   padding: 5px;
   font-size: 16px;
   border: 1px solid #ccc;
   text-align: center;
}


@media (max-width: 576px) {
   .table-container {
       overflow-x: auto;
   }

   table {
       min-width: 600px;
   }
}

ul#pills-tab.des-adv {
   display: flex;
   flex-direction: row;
   justify-content: center;
   align-items: center;
   gap: 10px; 
   flex-wrap: nowrap; 
   font-size: 12px;
}
ul#pills-tab.live-vod {
   font-size: 13px;
}
.Retain-Contents
{   font-size: 14px;
}
.video-table {
   width: 100%;
   border-collapse: collapse;
}

.live-item td {
   padding: 10px;
   
}
.errorr-img   
{
color: #ff2c2c !important;
font-size: 11px;
font-weight: 600;
}
.pics-thumbnail
{
   font-size: 11px !important;
}


@media (min-width:320px)  { 
   .clear-button {
      position: absolute;
      top: 10px;
      left: 78%;
      background: none;
      border: none;
      font-size: 20px;
      cursor: pointer;
      color: #aaa;
   } 
 }
@media (min-width:480px)  {
   
   .clear-button {
      position: absolute;
      top: 10px;
      left: 85%;
      background: none;
      border: none;
      font-size: 20px;
      cursor: pointer;
      color: #aaa;
   } 
 }
@media (min-width:600px)  {
    .clear-button {
   position: absolute;
   top: 10px;
   left: 85%;
   background: none;
   border: none;
   font-size: 20px;
   cursor: pointer;
   color: #aaa;
} }
@media (min-width:801px)  {
   .clear-button {
      position: absolute;
      top: 10px;
      left: 84%;
      background: none;
      border: none;
      font-size: 20px;
      cursor: pointer;
      color: #aaa;
   }
 }
@media (min-width:1025px) { 
   .clear-button {
      position: absolute;
      top: 10px;
      left: 92%;
      background: none;
      border: none;
      font-size: 20px;
      cursor: pointer;
      color: #aaa;
   }
 }
@media (min-width:1281px) { 
   
   .clear-button {
      position: absolute;
      top: 10px;
      left: 75%;
      background: none;
      border: none;
      font-size: 20px;
      cursor: pointer;
      color: #aaa;
   }
 }
@media (min-width:2560px) { 
   
   .clear-button {
      position: absolute;
      top: 10px;
      left: 88%;
      background: none;
      border: none;
      font-size: 20px;
      cursor: pointer;
      color: #aaa;
   }
 }
 .editable-text {
   outline: none;
   min-width: 1ch;
 }
 .pen-icon {
   pointer-events: none; /* So it doesn't interfere with typing */
   opacity: 0.5;
 }

 .pl-2{padding-left: .5rem !important;}
 .pr-2{padding-right: .5rem !important;}

 .breaks-container{
   max-width: 270px;
   width: 100%;
   background-size: 22px;
   background-repeat: no-repeat;
   background-position: 11px 13px;
   cursor: pointer;
   background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
   background-color: #ffff;
   color: #0000;
   padding: 13px 15px 13px 42px;
   border: 1px solid grey;
}
 .live-container, .video-container{
   max-width: 270px;
   width: 100%;
   background-size: 22px;
   background-repeat: no-repeat;
   background-position: 11px 20px;
   cursor: pointer;
   background-color: #ffff;
   color: #0000;
   padding: 10px 15px 10px 42px;
   margin: 8px 0;
   display: flex;
   align-items: center;
   justify-content: space-between;
   border:none;
}
.videos-wrapper, .live-wrapper{border:none;}
 .live-container{
   background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
 .video-container{
   background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.table-search{ border: 1px solid grey;}

.duration-field .errorred{font-size: 10px;}
 
 .vjs-has-started .vjs-control-bar{justify-content: space-between;}

 .breakUrl-input{right: 0;z-index: 1;bottom: 52px;}
 .breakUrl-input input{margin: 0 !important;}
 button.break-check,button.break-cancel{padding: 0 !important; margin: 0 !important;background-color: transparent !important;}
 button.break-check span{background: none;color: green;}
 button.break-cancel span{background: none;color: red;}
 #Schedule-date{border-bottom: 4px solid #e5e5ea;}
 .vjs-live .vjs-time-control{display: block;}
 .editplayouttdtd .content-lists{max-height: 35.4rem;overflow-y: auto;}
 .left-programs-list .tab-content{max-height: 27rem;}
 .custom-border-error .errorred{font-size: 10px;}
 .video-js.vjs-16-9:not(.vjs-audio-only-mode){padding-top: 33.25%;}

 /* Preview player must stay inside its 350px card. The uvf player builds
    absolute- and fixed-positioned layers that escape overflow:hidden
    (fixed positions against the viewport), creating a huge black region
    over the form. transform:translateZ(0) makes .playout-player the
    containing block for ALL descendants — including position:fixed — so
    every layer is laid out and clipped inside the card. */
 .playout-player{position: relative !important; transform: translateZ(0); height: 350px !important; overflow: hidden;}
 .playout-player .uvf-center-play-btn.uvf-pulse{display: none;}
 .playout-player .uvf-responsive-container{position: absolute !important; inset: 0 !important; width: 100% !important; height: 100% !important; max-height: none !important; padding: 0 !important;}
 .playout-player .uvf-player-container{position: relative !important; height: 100% !important; max-height: 100% !important;}
 .playout-player .uvf-player-wrapper{height: 100% !important; max-height: 100% !important;}
 .playout-player .uvf-video-container{height: 100% !important; max-height: 100% !important;}
 .playout-player video{width: 100% !important; height: 100% !important; max-height: 100% !important; object-fit: contain;}
 .uvf-top-bar, #uvf-unmute-btn, .uvf-controls-bar{z-index: 0 !important;}
 
/* Premium Search UI */
.search-container {
    position: relative;
    display: flex;
    align-items: center;
    background: #fdfdfd;
    border: 1px solid #ced4da;
    border-radius: 8px;
    padding: 0 12px;
    transition: all 0.3s ease;
    height: 42px;
    width: 100%;
}

.search-container:focus-within {
    border-color: #0d6efd;
    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
    background: #fff;
}

.search-icon {
    color: #adb5bd;
    margin-right: 10px;
    font-size: 14px;
}

.search-input {
    border: none !important;
    background: transparent !important;
    padding: 0 !important;
    width: 100%;
    outline: none !important;
    font-size: 14px;
    color: #212529;
}

.search-input::placeholder {
    color: #adb5bd;
    font-weight: 400;
}

.search-input::-webkit-search-cancel-button {
    -webkit-appearance: none;
}

.table-search {
    border: none !important;
}

.playout-video-list-scroll {
    max-height: 320px;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.14) transparent;
}
.playout-video-list-scroll::-webkit-scrollbar          { width: 4px; }
.playout-video-list-scroll::-webkit-scrollbar-track    { background: transparent; }
.playout-video-list-scroll::-webkit-scrollbar-thumb    { background: rgba(0, 0, 0, 0.14); border-radius: 4px; }
.playout-video-list-scroll::-webkit-scrollbar-thumb:hover { background: rgba(0, 0, 0, 0.28); }

.playout-video-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
}

.playout-video-title {
    display: block;
    font-size: 12.5px;
    font-weight: 600;
    line-height: 1.3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: default;
    letter-spacing: 0.01em;
}

.playout-video-meta {
    display: flex;
    align-items: center;
    gap: 5px;
    flex-wrap: nowrap;
    min-width: 0;
}

.playout-meta-pill {
    display: inline-flex;
    align-items: center;
    font-size: 9.5px;
    font-weight: 500;
    padding: 2px 7px;
    border-radius: 20px;
    line-height: 1.5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
    flex-shrink: 1;
}

/* Library tag — indigo accent */
/* .playout-meta-library {
    background: rgba(99, 102, 241, 0.10);
    color: #6366f1;
    border: 1px solid rgba(99, 102, 241, 0.20);
} */

/* Duration — emerald accent, monospaced digits */
.playout-meta-duration {
    /* background: rgba(16, 185, 129, 0.10); */
    color: #10b981;
    /* border: 1px solid rgba(16, 185, 129, 0.20); */
    font-variant-numeric: tabular-nums;
    letter-spacing: 0.02em;
    flex-shrink: 0;        /* never compress the duration — it must be fully readable */
}

/* ── Add (+) icon ───────────────────────────────────────── */
.playout-video-add-btn {
    display: block;
    font-size: 20px;
    color: #9ca3af;
    cursor: pointer;
    transition: color 0.18s ease, transform 0.15s ease;
}
.playout-video-add-btn:hover {
    color: #0d6efd;
    transform: scale(1.18);
}

/* ── Full-title tooltip ─────────────────────────────────── */
.playout-video-title-tooltip {
    font-size: 12px !important;
    max-width: 240px !important;
    word-break: break-word !important;
    padding: 6px 10px !important;
    border-radius: 6px !important;
    line-height: 1.55 !important;
    z-index: 9999 !important;
    text-align: left !important;
}

/* ═══════════════════════════════════════════════════════════════
   Scheduled Program List — Currently-Playing Row Highlight
   Works even under the parent's opacity: 0.6 (live mode dimming)
   by using a strong-enough background so it remains clearly visible.
═══════════════════════════════════════════════════════════════ */

/* Active row: left emerald bar + subtle green wash */
.playout-row-active {
    background: rgba(16, 185, 129, 0.22) !important;
    box-shadow: inset 4px 0 0 0 #10b981;
    transition: background 0.4s ease;
    position: relative;
}

/* ── "NOW" badge — inline with the program title ───────── */
.playout-now-playing-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    color: #059669;           /* slightly darker so text is readable at 0.6 parent opacity */
    background: rgba(16, 185, 129, 0.18);
    border: 1px solid rgba(16, 185, 129, 0.40);
    padding: 2px 8px 2px 5px;
    border-radius: 20px;
    white-space: nowrap;
    flex-shrink: 0;
    vertical-align: middle;
    position: relative;
    top: -1px;
}

/* Pulsing live-indicator dot inside the badge */
.playout-now-dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #10b981;
    flex-shrink: 0;
    animation: playout-dot-pulse 1.5s ease-in-out infinite;
}

@keyframes playout-dot-pulse {
    0%   { opacity: 1;   transform: scale(1);    }
    50%  { opacity: 0.35; transform: scale(0.7); }
    100% { opacity: 1;   transform: scale(1);    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Tv_Playout/EditTvplayouts.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;CACxB;;CAEA;;;;;;;;;IASG;;CAEH;IACG,WAAW;CACd;CACA;GACE,YAAY;GACZ,gBAAgB;GAChB,eAAe;GACf,kCAAkC;AACrC;;AAEA;GACG,qBAAqB;AACxB;AACA;GACG,aAAa;GACb,oBAAoB;GACpB,eAAe;AAClB;AACA;GACG,iBAAiB;GACjB,sBAAsB;GACtB,kBAAkB;GAClB,YAAY;AACf;AACA;;GAEG,iCAAiC;AACpC;AACA;OACO,uCAAuC;AAC9C;AACA;GACG,iBAAiB;GACjB,YAAY;GACZ,kBAAkB;GAClB,eAAe;GACf,iCAAiC;AACpC;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,yCAAyC;AAC5C;;AAEA;GACG,eAAe;AAClB;AACA;;GAEG,eAAe;AAClB;AACA;GACG,uBAAuB;GACvB,oCAAoC;GACpC,gCAAgC;GAChC,2BAA2B;GAC3B,gBAAgB;AACnB;;AAEA;GACG,yBAAyB;GACzB,2CAA2C;AAC9C;AACA;GACG,yBAAyB;GACzB,aAAa;GACb,kBAAkB;CACpB;;CAEA,oBAAoB;CACpB;GACE,aAAa;GACb,gCAAgC;CAClC;;CAEA;GACE,WAAW;GACX,uBAAuB;GACvB,YAAY;GACZ,eAAe;GACf,iBAAiB;CACnB;;CAEA;GACE,cAAc;GACd,iBAAiB;GACjB,gCAAgC;CAClC;;AAED,uBAAuB;AACvB;GACG,aAAa;GACb,mBAAmB;GACnB,YAAY;GACZ,WAAW;GACX,sBAAsB;GACtB,kBAAkB;GAClB,iBAAiB;GACjB,kBAAkB;AACrB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,iBAAiB;GACjB,sBAAsB;GACtB,cAAc;GACd;AACH;;AAEA;GACG,aAAa;GACb,mBAAmB;AACtB;;AAEA;GACG,SAAO;GACP,iBAAiB;GACjB,YAAY;GACZ,aAAa;GACb,eAAe;AAClB;;AAEA,uBAAuB;AACvB;GACG,aAAa;GACb,mBAAmB;GACnB,8BAA8B;GAC9B,YAAY;GACZ,WAAW;GACX,sBAAsB;GACtB,kBAAkB;GAClB,aAAa;GACb,iBAAiB;AACpB;;AAEA;GACG,eAAe;GACf,eAAe;GACf,WAAW;GACX,gBAAgB;AACnB;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,eAAe;GACf,WAAW;AACd;AACA;GACG,eAAe;GACf,WAAW;AACd;;AAEA;GACG,eAAe;GACf,eAAe;GACf,WAAW;GACX,gBAAgB;AACnB;;AAEA;GACG,YAAY;AACf;;CAEC;GACE,WAAW;GACX,gBAAgB;CAClB;CACA;GACE,WAAW;GACX,gBAAgB;CAClB;;CAEA;GACE,2BAA2B;GAC3B,mBAAmB;GACnB,qCAAqC;GACrC,kBAAkB;AACrB;CACC;;GAEE,aAAa;GACb,mBAAmB;GACnB,qCAAqC;GACrC,kBAAkB;;CAEpB;CACA;GACE,2BAA2B;GAC3B,mBAAmB;GACnB,qCAAqC;GACrC,kBAAkB;GAClB,WAAW;;CAEb;CACA;GACE,qCAAqC;AACxC;;CAEC;GACE,YAAY;GACZ,iBAAiB;CACnB;;CAEA;GACE,cAAc;GACd,eAAe;GACf,eAAe;CACjB;CACA;GACE,aAAa;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB;AACJ;AACA;GACG,gBAAgB;GAChB,mBAAmB;GACnB,qBAAqB;GACrB,iBAAiB;GACjB,gBAAgB;GAChB,YAAY;GACZ,wBAAwB;GACxB,kBAAkB;AACrB;AACA;GACG,gBAAgB;GAChB,mBAAmB;GACnB,qBAAqB;GACrB,iBAAiB;GACjB,aAAa;AAChB;AACA;GACG,gBAAgB;AACnB;AACA;GACG,YAAY;GACZ,YAAY;GACZ,iBAAiB;GACjB,kBAAkB;GAClB,YAAY;GACZ,eAAe;GACf,sBAAsB;GACtB,kBAAkB;AACrB;;;AAGA;GACG;OACI,gBAAgB;GACpB;;GAEA;OACI,gBAAgB;GACpB;AACH;;AAEA;GACG,aAAa;GACb,mBAAmB;GACnB,uBAAuB;GACvB,mBAAmB;GACnB,SAAS;GACT,iBAAiB;GACjB,eAAe;AAClB;AACA;GACG,eAAe;AAClB;AACA;IACI,eAAe;AACnB;AACA;GACG,WAAW;GACX,yBAAyB;AAC5B;;AAEA;GACG,aAAa;;AAEhB;AACA;;AAEA,yBAAyB;AACzB,eAAe;AACf,gBAAgB;AAChB;AACA;;GAEG,0BAA0B;AAC7B;;;AAGA;GACG;MACG,kBAAkB;MAClB,SAAS;MACT,SAAS;MACT,gBAAgB;MAChB,YAAY;MACZ,eAAe;MACf,eAAe;MACf,WAAW;GACd;CACF;AACD;;GAEG;MACG,kBAAkB;MAClB,SAAS;MACT,SAAS;MACT,gBAAgB;MAChB,YAAY;MACZ,eAAe;MACf,eAAe;MACf,WAAW;GACd;CACF;AACD;IACI;GACD,kBAAkB;GAClB,SAAS;GACT,SAAS;GACT,gBAAgB;GAChB,YAAY;GACZ,eAAe;GACf,eAAe;GACf,WAAW;AACd,EAAE;AACF;GACG;MACG,kBAAkB;MAClB,SAAS;MACT,SAAS;MACT,gBAAgB;MAChB,YAAY;MACZ,eAAe;MACf,eAAe;MACf,WAAW;GACd;CACF;AACD;GACG;MACG,kBAAkB;MAClB,SAAS;MACT,SAAS;MACT,gBAAgB;MAChB,YAAY;MACZ,eAAe;MACf,eAAe;MACf,WAAW;GACd;CACF;AACD;;GAEG;MACG,kBAAkB;MAClB,SAAS;MACT,SAAS;MACT,gBAAgB;MAChB,YAAY;MACZ,eAAe;MACf,eAAe;MACf,WAAW;GACd;CACF;AACD;;GAEG;MACG,kBAAkB;MAClB,SAAS;MACT,SAAS;MACT,gBAAgB;MAChB,YAAY;MACZ,eAAe;MACf,eAAe;MACf,WAAW;GACd;CACF;CACA;GACE,aAAa;GACb,cAAc;CAChB;CACA;GACE,oBAAoB,EAAE,wCAAwC;GAC9D,YAAY;CACd;;CAEA,MAAM,8BAA8B,CAAC;CACrC,MAAM,+BAA+B,CAAC;;CAEtC;GACE,gBAAgB;GAChB,WAAW;GACX,qBAAqB;GACrB,4BAA4B;GAC5B,8BAA8B;GAC9B,eAAe;GACf,yDAA6D;GAC7D,uBAAuB;GACvB,YAAY;GACZ,4BAA4B;GAC5B,sBAAsB;AACzB;CACC;GACE,gBAAgB;GAChB,WAAW;GACX,qBAAqB;GACrB,4BAA4B;GAC5B,8BAA8B;GAC9B,eAAe;GACf,uBAAuB;GACvB,YAAY;GACZ,4BAA4B;GAC5B,aAAa;GACb,aAAa;GACb,mBAAmB;GACnB,8BAA8B;GAC9B,WAAW;AACd;AACA,+BAA+B,WAAW,CAAC;CAC1C;GACE,yDAAiE;AACpE;CACC;GACE,yDAAkE;AACrE;AACA,eAAe,sBAAsB,CAAC;;AAEtC,0BAA0B,eAAe,CAAC;;CAEzC,kCAAkC,8BAA8B,CAAC;;CAEjE,gBAAgB,QAAQ,CAAC,UAAU,CAAC,YAAY,CAAC;CACjD,sBAAsB,oBAAoB,CAAC;CAC3C,uCAAuC,qBAAqB,EAAE,oBAAoB,CAAC,wCAAwC,CAAC;CAC5H,wBAAwB,gBAAgB,CAAC,YAAY,CAAC;CACtD,yBAAyB,gBAAgB,CAAC,UAAU,CAAC;CACrD,eAAe,gCAAgC,CAAC;CAChD,4BAA4B,cAAc,CAAC;CAC3C,gCAAgC,mBAAmB,CAAC,gBAAgB,CAAC;CACrE,iCAAiC,iBAAiB,CAAC;CACnD,+BAA+B,eAAe,CAAC;CAC/C,6CAA6C,mBAAmB,CAAC;;CAEjE;;;;;0DAKyD;CACzD,gBAAgB,6BAA6B,EAAE,wBAAwB,EAAE,wBAAwB,EAAE,gBAAgB,CAAC;CACpH,+CAA+C,aAAa,CAAC;CAC7D,0CAA0C,6BAA6B,EAAE,mBAAmB,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,2BAA2B,EAAE,qBAAqB,CAAC;CAClM,sCAAsC,6BAA6B,EAAE,uBAAuB,EAAE,2BAA2B,CAAC;CAC1H,oCAAoC,uBAAuB,EAAE,2BAA2B,CAAC;CACzF,qCAAqC,uBAAuB,EAAE,2BAA2B,CAAC;CAC1F,sBAAsB,sBAAsB,EAAE,uBAAuB,EAAE,2BAA2B,EAAE,mBAAmB,CAAC;CACxH,iDAAiD,qBAAqB,CAAC;;AAExE,sBAAsB;AACtB;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;IAC7C,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,kCAAkC;IAClC,qBAAqB;IACrB,WAAW;IACX,wBAAwB;IACxB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,gDAAgD;AACpD;AACA,yDAAyD,UAAU,EAAE;AACrE,yDAAyD,uBAAuB,EAAE;AAClF,yDAAyD,+BAA+B,EAAE,kBAAkB,EAAE;AAC9G,4DAA4D,+BAA+B,EAAE;;AAE7F;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,gCAAgC;AAChC;;;;GAIG;;AAEH,iDAAiD;AACjD;IACI,0CAA0C;IAC1C,cAAc;IACd,gDAAgD;IAChD,kCAAkC;IAClC,sBAAsB;IACtB,cAAc,SAAS,4DAA4D;AACvF;;AAEA,8DAA8D;AAC9D;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;IACf,kDAAkD;AACtD;AACA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA,8DAA8D;AAC9D;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,iCAAiC;IACjC,4BAA4B;IAC5B,6BAA6B;IAC7B,4BAA4B;IAC5B,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;;;;iEAIiE;;AAEjE,qDAAqD;AACrD;IACI,+CAA+C;IAC/C,mCAAmC;IACnC,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA,6DAA6D;AAC7D;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc,YAAY,8DAA8D;IACxF,oCAAoC;IACpC,0CAA0C;IAC1C,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;AACb;;AAEA,gDAAgD;AAChD;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,sDAAsD;AAC1D;;AAEA;IACI,OAAO,UAAU,IAAI,mBAAmB,KAAK;IAC7C,OAAO,aAAa,EAAE,qBAAqB,EAAE;IAC7C,OAAO,UAAU,IAAI,mBAAmB,KAAK;AACjD","sourcesContent":[".input-container {\n    position: relative;\n    display: inline-block;\n }\n\n /* .clear-button {\n    position: absolute;\n    top: 10px;\n    left: 80%;\n    background: none;\n    border: none;\n    font-size: 20px;\n    cursor: pointer;\n    color: #aaa;\n } */\n \n .clear-button:hover {\n    color: #000;\n }\n .remove-text {\n   color: black; \n   font-weight: 600; \n   cursor: pointer;\n   transition: color 0.2s ease-in-out; \n}\n\n.remove-text:hover {\n   color: red !important;\n}\n.payout-actions {\n   display: flex;\n   align-self: self-end;\n   margin-top: 5px;\n}\n.payout-disable-btn {\n   padding: 5px 10px;\n   border: 1px solid grey;\n   border-radius: 5px;\n   color: black;\n}\n.payout-disable-btn:hover \n{\n   background-color: #aaa !important; \n}\n.editplayouttdtd td{\n       padding: 20px 20px 20px 10px !important;\n}\n.payout-delete-btn {\n   padding: 5px 10px;\n   border: none;\n   border-radius: 5px;\n   cursor: pointer;\n   transition: background-color 0.3s;\n}\n\n.payout-delete-btn:hover {\n   color: red;;\n}\n\n.custom-fade-modal .modal-backdrop {\n   background: rgba(0, 0, 0, 0.5) !important; \n}\n\n.custom-fade-modal .modal-content {\n   animation: none;\n}\n.adjust-retain\n{\n   font-size: 15px;\n}\n.live-custom, .vod-custom {\n   color: black !important;\n   border-bottom: 2px solid transparent; \n   transition: all 0.3s ease-in-out;\n   font-weight: 700 !important;\n   margin-top: 22px;\n}\n\n.live-custom.active, .vod-custom.active {\n   color: #0d6efd !important; \n   border-bottom: 2px solid #0d6efd !important; \n}\n.livestream-container {\n   background-color: #10172a;\n   padding: 10px;\n   border-radius: 8px;\n }\n \n /* Navigation Tabs */\n .custom-nav-tabs {\n   display: flex;\n   border-bottom: 1px solid #394b68;\n }\n \n .tab-live, .tab-vod {\n   color: #ccc;\n   background: transparent;\n   border: none;\n   font-size: 14px;\n   padding: 8px 12px;\n }\n \n .tab-live.active {\n   color: #007bff;\n   font-weight: bold;\n   border-bottom: 2px solid #007bff;\n }\n \n/* Search Box Styling */\n.search-wrapper {\n   display: flex;\n   align-items: center;\n   padding: 5px;\n   width: 100%;\n   border: 1px solid grey;\n   border-radius: 5px;\n   background: white;\n   position: relative;\n}\n\n.edittv_icon {\n   width: 20px;\n   height: 20px;\n   margin-right: 8px; \n   vertical-align: middle;\n   font-size: 8px;\n   color:#b9b9b9\n}\n\n.search-wrapper, .break-wrapper {\n   display: flex;\n   align-items: center;\n}\n\n.search-box {\n   flex: 1;\n   padding: 8px 10px;\n   border: none;\n   outline: none;\n   font-size: 14px;\n}\n\n/* Breaks Row Styling */\n.breaks-container {\n   display: flex;\n   align-items: center;\n   justify-content: space-between;\n   padding: 8px;\n   width: 100%;\n   border: 1px solid grey;\n   border-radius: 5px;\n   margin: 8px 0;\n   background: white;\n}\n\n.break-add-icon {\n   cursor: pointer;\n   font-size: 20px;\n   color: grey;\n   transition: 0.3s;\n}\n\n.break-add-icon:hover {\n   color: black;\n}\n\n.video-thumb {\n   font-size: 18px;\n   color: grey;\n}\n.editimglive {\n   font-size: 50px;\n   color: grey;\n}\n\n.live-add-icon {\n   cursor: pointer;\n   font-size: 20px;\n   color: grey;\n   transition: 0.3s;\n}\n\n.live-add-icon:hover {\n   color: black;\n}\n\n .livestream-table {\n   width: 100%;\n   margin-top: 10px;\n }\n .video-table {\n   width: 100%;\n   margin-top: 10px;\n }\n\n .live-item {\n   display: inherit !important;\n   align-items: center;\n   border-bottom: transparent !important;\n   margin-bottom: 5px;\n}\n .breaks-row\n {\n   display: flex;\n   align-items: center;\n   border-bottom: transparent !important;\n   margin-bottom: 5px;\n\n }\n .video-item {\n   display: inherit !important;\n   align-items: center;\n   border-bottom: transparent !important;\n   margin-bottom: 5px;\n   width: 100%;\n\n }\n .breaks-container td {\n   border-bottom: transparent !important;\n}\n\n .break-icon, .video-icon {\n   color: white;\n   margin-right: 8px;\n }\n \n .add-icon {\n   color: #007bff;\n   font-size: 20px;\n   cursor: pointer;\n }\n .middle-content {\n   display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    font-size: 20px;\n    bottom: 10px !important;\n    margin-top: 20%\n}\n.tooltip-retain-content {\n   max-width: 180px; \n   white-space: normal;\n   word-wrap: break-word;\n   text-align: start;\n   line-height: 1.4;\n   padding: 5px;\n   z-index: 9999 !important;\n   position: relative; \n}\n.tooltip-break-content {\n   max-width: 300px;\n   white-space: normal;\n   word-wrap: break-word;\n   text-align: start;\n   z-index: 1050; \n}\n.tooltip-break-wrapper {\n   overflow: hidden;\n}\n.custom-time-picker {\n   width: 200px;\n   height: 40px;\n   background: white;\n   border-radius: 6px;\n   padding: 5px;\n   font-size: 16px;\n   border: 1px solid #ccc;\n   text-align: center;\n}\n\n\n@media (max-width: 576px) {\n   .table-container {\n       overflow-x: auto;\n   }\n\n   table {\n       min-width: 600px;\n   }\n}\n\nul#pills-tab.des-adv {\n   display: flex;\n   flex-direction: row;\n   justify-content: center;\n   align-items: center;\n   gap: 10px; \n   flex-wrap: nowrap; \n   font-size: 12px;\n}\nul#pills-tab.live-vod {\n   font-size: 13px;\n}\n.Retain-Contents\n{   font-size: 14px;\n}\n.video-table {\n   width: 100%;\n   border-collapse: collapse;\n}\n\n.live-item td {\n   padding: 10px;\n   \n}\n.errorr-img   \n{\ncolor: #ff2c2c !important;\nfont-size: 11px;\nfont-weight: 600;\n}\n.pics-thumbnail\n{\n   font-size: 11px !important;\n}\n\n\n@media (min-width:320px)  { \n   .clear-button {\n      position: absolute;\n      top: 10px;\n      left: 78%;\n      background: none;\n      border: none;\n      font-size: 20px;\n      cursor: pointer;\n      color: #aaa;\n   } \n }\n@media (min-width:480px)  {\n   \n   .clear-button {\n      position: absolute;\n      top: 10px;\n      left: 85%;\n      background: none;\n      border: none;\n      font-size: 20px;\n      cursor: pointer;\n      color: #aaa;\n   } \n }\n@media (min-width:600px)  {\n    .clear-button {\n   position: absolute;\n   top: 10px;\n   left: 85%;\n   background: none;\n   border: none;\n   font-size: 20px;\n   cursor: pointer;\n   color: #aaa;\n} }\n@media (min-width:801px)  {\n   .clear-button {\n      position: absolute;\n      top: 10px;\n      left: 84%;\n      background: none;\n      border: none;\n      font-size: 20px;\n      cursor: pointer;\n      color: #aaa;\n   }\n }\n@media (min-width:1025px) { \n   .clear-button {\n      position: absolute;\n      top: 10px;\n      left: 92%;\n      background: none;\n      border: none;\n      font-size: 20px;\n      cursor: pointer;\n      color: #aaa;\n   }\n }\n@media (min-width:1281px) { \n   \n   .clear-button {\n      position: absolute;\n      top: 10px;\n      left: 75%;\n      background: none;\n      border: none;\n      font-size: 20px;\n      cursor: pointer;\n      color: #aaa;\n   }\n }\n@media (min-width:2560px) { \n   \n   .clear-button {\n      position: absolute;\n      top: 10px;\n      left: 88%;\n      background: none;\n      border: none;\n      font-size: 20px;\n      cursor: pointer;\n      color: #aaa;\n   }\n }\n .editable-text {\n   outline: none;\n   min-width: 1ch;\n }\n .pen-icon {\n   pointer-events: none; /* So it doesn't interfere with typing */\n   opacity: 0.5;\n }\n\n .pl-2{padding-left: .5rem !important;}\n .pr-2{padding-right: .5rem !important;}\n\n .breaks-container{\n   max-width: 270px;\n   width: 100%;\n   background-size: 22px;\n   background-repeat: no-repeat;\n   background-position: 11px 13px;\n   cursor: pointer;\n   background-image: url(\"../../components/Images/break-ad.png\");\n   background-color: #ffff;\n   color: #0000;\n   padding: 13px 15px 13px 42px;\n   border: 1px solid grey;\n}\n .live-container, .video-container{\n   max-width: 270px;\n   width: 100%;\n   background-size: 22px;\n   background-repeat: no-repeat;\n   background-position: 11px 20px;\n   cursor: pointer;\n   background-color: #ffff;\n   color: #0000;\n   padding: 10px 15px 10px 42px;\n   margin: 8px 0;\n   display: flex;\n   align-items: center;\n   justify-content: space-between;\n   border:none;\n}\n.videos-wrapper, .live-wrapper{border:none;}\n .live-container{\n   background-image: url(\"../../components/Images/playout-live.png\");\n}\n .video-container{\n   background-image: url(\"../../components/Images/playout-video.png\");\n}\n.table-search{ border: 1px solid grey;}\n\n.duration-field .errorred{font-size: 10px;}\n \n .vjs-has-started .vjs-control-bar{justify-content: space-between;}\n\n .breakUrl-input{right: 0;z-index: 1;bottom: 52px;}\n .breakUrl-input input{margin: 0 !important;}\n button.break-check,button.break-cancel{padding: 0 !important; margin: 0 !important;background-color: transparent !important;}\n button.break-check span{background: none;color: green;}\n button.break-cancel span{background: none;color: red;}\n #Schedule-date{border-bottom: 4px solid #e5e5ea;}\n .vjs-live .vjs-time-control{display: block;}\n .editplayouttdtd .content-lists{max-height: 35.4rem;overflow-y: auto;}\n .left-programs-list .tab-content{max-height: 27rem;}\n .custom-border-error .errorred{font-size: 10px;}\n .video-js.vjs-16-9:not(.vjs-audio-only-mode){padding-top: 33.25%;}\n\n /* Preview player must stay inside its 350px card. The uvf player builds\n    absolute- and fixed-positioned layers that escape overflow:hidden\n    (fixed positions against the viewport), creating a huge black region\n    over the form. transform:translateZ(0) makes .playout-player the\n    containing block for ALL descendants — including position:fixed — so\n    every layer is laid out and clipped inside the card. */\n .playout-player{position: relative !important; transform: translateZ(0); height: 350px !important; overflow: hidden;}\n .playout-player .uvf-center-play-btn.uvf-pulse{display: none;}\n .playout-player .uvf-responsive-container{position: absolute !important; inset: 0 !important; width: 100% !important; height: 100% !important; max-height: none !important; padding: 0 !important;}\n .playout-player .uvf-player-container{position: relative !important; height: 100% !important; max-height: 100% !important;}\n .playout-player .uvf-player-wrapper{height: 100% !important; max-height: 100% !important;}\n .playout-player .uvf-video-container{height: 100% !important; max-height: 100% !important;}\n .playout-player video{width: 100% !important; height: 100% !important; max-height: 100% !important; object-fit: contain;}\n .uvf-top-bar, #uvf-unmute-btn, .uvf-controls-bar{z-index: 0 !important;}\n \n/* Premium Search UI */\n.search-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n    background: #fdfdfd;\n    border: 1px solid #ced4da;\n    border-radius: 8px;\n    padding: 0 12px;\n    transition: all 0.3s ease;\n    height: 42px;\n    width: 100%;\n}\n\n.search-container:focus-within {\n    border-color: #0d6efd;\n    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);\n    background: #fff;\n}\n\n.search-icon {\n    color: #adb5bd;\n    margin-right: 10px;\n    font-size: 14px;\n}\n\n.search-input {\n    border: none !important;\n    background: transparent !important;\n    padding: 0 !important;\n    width: 100%;\n    outline: none !important;\n    font-size: 14px;\n    color: #212529;\n}\n\n.search-input::placeholder {\n    color: #adb5bd;\n    font-weight: 400;\n}\n\n.search-input::-webkit-search-cancel-button {\n    -webkit-appearance: none;\n}\n\n.table-search {\n    border: none !important;\n}\n\n.playout-video-list-scroll {\n    max-height: 320px;\n    overflow-y: auto;\n    scrollbar-width: thin;\n    scrollbar-color: rgba(0, 0, 0, 0.14) transparent;\n}\n.playout-video-list-scroll::-webkit-scrollbar          { width: 4px; }\n.playout-video-list-scroll::-webkit-scrollbar-track    { background: transparent; }\n.playout-video-list-scroll::-webkit-scrollbar-thumb    { background: rgba(0, 0, 0, 0.14); border-radius: 4px; }\n.playout-video-list-scroll::-webkit-scrollbar-thumb:hover { background: rgba(0, 0, 0, 0.28); }\n\n.playout-video-info {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 0;\n}\n\n.playout-video-title {\n    display: block;\n    font-size: 12.5px;\n    font-weight: 600;\n    line-height: 1.3;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor: default;\n    letter-spacing: 0.01em;\n}\n\n.playout-video-meta {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    flex-wrap: nowrap;\n    min-width: 0;\n}\n\n.playout-meta-pill {\n    display: inline-flex;\n    align-items: center;\n    font-size: 9.5px;\n    font-weight: 500;\n    padding: 2px 7px;\n    border-radius: 20px;\n    line-height: 1.5;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 120px;\n    flex-shrink: 1;\n}\n\n/* Library tag — indigo accent */\n/* .playout-meta-library {\n    background: rgba(99, 102, 241, 0.10);\n    color: #6366f1;\n    border: 1px solid rgba(99, 102, 241, 0.20);\n} */\n\n/* Duration — emerald accent, monospaced digits */\n.playout-meta-duration {\n    /* background: rgba(16, 185, 129, 0.10); */\n    color: #10b981;\n    /* border: 1px solid rgba(16, 185, 129, 0.20); */\n    font-variant-numeric: tabular-nums;\n    letter-spacing: 0.02em;\n    flex-shrink: 0;        /* never compress the duration — it must be fully readable */\n}\n\n/* ── Add (+) icon ───────────────────────────────────────── */\n.playout-video-add-btn {\n    display: block;\n    font-size: 20px;\n    color: #9ca3af;\n    cursor: pointer;\n    transition: color 0.18s ease, transform 0.15s ease;\n}\n.playout-video-add-btn:hover {\n    color: #0d6efd;\n    transform: scale(1.18);\n}\n\n/* ── Full-title tooltip ─────────────────────────────────── */\n.playout-video-title-tooltip {\n    font-size: 12px !important;\n    max-width: 240px !important;\n    word-break: break-word !important;\n    padding: 6px 10px !important;\n    border-radius: 6px !important;\n    line-height: 1.55 !important;\n    z-index: 9999 !important;\n    text-align: left !important;\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Scheduled Program List — Currently-Playing Row Highlight\n   Works even under the parent's opacity: 0.6 (live mode dimming)\n   by using a strong-enough background so it remains clearly visible.\n═══════════════════════════════════════════════════════════════ */\n\n/* Active row: left emerald bar + subtle green wash */\n.playout-row-active {\n    background: rgba(16, 185, 129, 0.22) !important;\n    box-shadow: inset 4px 0 0 0 #10b981;\n    transition: background 0.4s ease;\n    position: relative;\n}\n\n/* ── \"NOW\" badge — inline with the program title ───────── */\n.playout-now-playing-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    font-size: 9px;\n    font-weight: 700;\n    letter-spacing: 0.09em;\n    text-transform: uppercase;\n    color: #059669;           /* slightly darker so text is readable at 0.6 parent opacity */\n    background: rgba(16, 185, 129, 0.18);\n    border: 1px solid rgba(16, 185, 129, 0.40);\n    padding: 2px 8px 2px 5px;\n    border-radius: 20px;\n    white-space: nowrap;\n    flex-shrink: 0;\n    vertical-align: middle;\n    position: relative;\n    top: -1px;\n}\n\n/* Pulsing live-indicator dot inside the badge */\n.playout-now-dot {\n    display: inline-block;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #10b981;\n    flex-shrink: 0;\n    animation: playout-dot-pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes playout-dot-pulse {\n    0%   { opacity: 1;   transform: scale(1);    }\n    50%  { opacity: 0.35; transform: scale(0.7); }\n    100% { opacity: 1;   transform: scale(1);    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
